var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"m-0 px-2 h3 font-weight-bold",attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }